import styled from '@emotion/styled';
import { Flex, Link } from '@qga/roo-ui/components';
import { useHeaderContext } from '../../HeaderContext';
import { themeGet } from 'styled-system';

export const QffLinks = () => {
  const { qffLinks, onInteraction } = useHeaderContext();
  return (
    <Flex py={5} flexDirection="column">
      {qffLinks?.map(({ trackingName, ...link }) => (
        <StyledLink
          key={trackingName}
          onClick={() =>
            onInteraction({
              type: 'QFF Login Dropdown',
              value: `${trackingName} Selected`,
            })
          }
          {...link}
        />
      ))}
    </Flex>
  );
};

const StyledLink = styled(Link)`
  color: ${themeGet('colors.greys.charcoal')};
  padding-left: ${themeGet('space.5')};
  margin-bottom: ${themeGet('space.2')};
`;
